// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth, signInWithPopup, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDEjC0zPh2HmLvqNi9PQhyCg_yG2LdktQk",
  authDomain: "fantasy-b5cf0.firebaseapp.com",
  projectId: "fantasy-b5cf0",
  storageBucket: "fantasy-b5cf0.appspot.com",
  messagingSenderId: "427488064366",
  appId: "1:427488064366:web:577c74e7d3abd6581f877f",
  measurementId: "G-XG6J4K8WE1"
};

// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig);
// Initialize Firebase Auth provider
const provider = new GoogleAuthProvider();
  
// whenever a user interacts with the provider, we force them to select an account
provider.setCustomParameters({   
    prompt : "select_account "
});
export const auth = getAuth();
export const signInWithGooglePopup = () => signInWithPopup(auth, provider);
export const db = getFirestore(firebaseApp)